import React, { useState, useContext } from "react";
import MenuItem from "@material-ui/core/MenuItem";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import { Menu } from "@material-ui/core";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import toastError from "../../errors/toastError";

const MessageOptionsMenu = ({ message, menuOpen, handleClose, anchorEl }) => {
  const { setReplyingMessage } = useContext(ReplyMessageContext);
  const [confirmationOpen, setConfirmationOpen] = useState(false);

  const handleDeleteMessage = async () => {
    try {
      await api.delete(`/messages/${message.id}`);
    } catch (err) {
      toastError(err);
    }
  };

  const handleReplyMessage = () => {
    setReplyingMessage(message);
    handleClose();
  };

  const handleOpenConfirmationModal = (e) => {
    setConfirmationOpen(true);
    handleClose();
  };

  const handleSendReaction = async (emoji) => {
    try {
      await api.put(`/messages/${message.id}/reaction`, { reaction: emoji });
      handleClose();
    } catch (err) {
      toastError(err);
    }
  };

  const handleEditMessage = async () => {
    handleClose();
    const newBody = window.prompt("Editar mensagem:", message.body);
    if (newBody === null || newBody.trim() === "") return;

    try {
      await api.put(`/messages/${message.id}`, { body: newBody });
    } catch (err) {
      toastError(err);
    }
  };

  const isWithinEditWindow = () => {
    if (!message?.createdAt) return false;
    const messageTime = new Date(message.createdAt).getTime();
    const currentTime = new Date().getTime();
    return currentTime - messageTime < 15 * 60 * 1000;
  };

  return (
    <>
      <ConfirmationModal
        title={i18n.t("messageOptionsMenu.confirmationModal.title")}
        open={confirmationOpen}
        onClose={setConfirmationOpen}
        onConfirm={handleDeleteMessage}
      >
        {i18n.t("messageOptionsMenu.confirmationModal.message")}
      </ConfirmationModal>
      <Menu
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={menuOpen}
        onClose={handleClose}
      >
        {/* FILEIRA DE REAÇÕES RÁPIDAS NO TOPO DO MENU */}
        {!message.isDeleted && (
          <div style={{ display: "flex", padding: "4px 8px", gap: "6px", backgroundColor: "#f5f5f5", borderBottom: "1px solid #e0e0e0" }}>
            {["👍", "❤️", "😂", "😮", "😢", "🙏"].map((emoji) => (
              <span
                key={emoji}
                onClick={() => handleSendReaction(emoji)}
                style={{ fontSize: "18px", cursor: "pointer", transition: "transform 0.1s", userSelect: "none" }}
                onMouseEnter={(e) => e.target.style.transform = "scale(1.2)"}
                onMouseLeave={(e) => e.target.style.transform = "scale(1)"}
              >
                {emoji}
              </span>
            ))}
          </div>
        )}

        {!message.isDeleted && (
          <MenuItem onClick={handleOpenConfirmationModal}>
            {i18n.t("messageOptionsMenu.delete")}
          </MenuItem>
        )}
        {message.fromMe && !message.isDeleted && isWithinEditWindow() && (
          <MenuItem onClick={handleEditMessage}>
            Editar Mensagem
          </MenuItem>
        )}
        <MenuItem onClick={handleReplyMessage}>
          {i18n.t("messageOptionsMenu.reply")}
        </MenuItem>
      </Menu>
    </>
  );
};

export default MessageOptionsMenu;
